
/* maxjenny! Product Gallery Navigation */

(() => {
  const SELECTOR = 'media-gallery';

  function initGallery(gallery) {
    if (gallery.dataset.mjNavigationReady === 'true') return;

    const prev = gallery.querySelector('[data-mj-gallery-prev]');
    const next = gallery.querySelector('[data-mj-gallery-next]');
    const viewer = gallery.querySelector('[id^="GalleryViewer-"]');

    if (!prev || !next || !viewer) return;

    gallery.dataset.mjNavigationReady = 'true';

    function getSlides() {
      return Array.from(
        viewer.querySelectorAll('.product__media-item')
      ).filter(slide => slide.getClientRects().length > 0);
    }

    function getCurrentIndex(slides) {
      const active = gallery.querySelector(
        '.product__media-item.is-active'
      );

      const index = slides.indexOf(active);
      return index >= 0 ? index : 0;
    }

    function navigate(direction) {
      const slides = getSlides();
      if (slides.length < 2) return;

      const current = getCurrentIndex(slides);
      const target = Math.max(
        0,
        Math.min(slides.length - 1, current + direction)
      );

      if (target === current) return;

      const targetSlide = slides[target];
      const mediaId = targetSlide.dataset.mediaId;

      if (typeof gallery.setActiveMedia === 'function' && mediaId) {
        gallery.setActiveMedia(mediaId, false);
      } else {
        targetSlide.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest'
        });
      }

      updateButtons();
    }

    function updateButtons() {
      const slides = getSlides();
      const index = getCurrentIndex(slides);

      prev.disabled = slides.length < 2 || index === 0;
      next.disabled = slides.length < 2 || index === slides.length - 1;
    }

    prev.addEventListener('click', () => navigate(-1));
    next.addEventListener('click', () => navigate(1));

    const observer = new MutationObserver(updateButtons);

    observer.observe(viewer, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    gallery.addEventListener('slideChanged', updateButtons);

    updateButtons();
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
